import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Matches from "@/pages/Matches";
import Predictions from "@/pages/Predictions";
import Rankings from "@/pages/Rankings";
import Profile from "@/pages/Profile";
import Rules from "@/pages/Rules";
import Prizes from "@/pages/Prizes";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Users from "@/pages/admin/Users";
import Countries from "@/pages/admin/Countries";
import Stages from "@/pages/admin/Stages";
import Stadiums from "@/pages/admin/Stadiums";
import Venues from "@/pages/admin/Venues";
import MatchesAdmin from "@/pages/admin/MatchesAdmin";
import Results from "@/pages/admin/Results";
import RulesAdmin from "@/pages/admin/Rules";
import PrizesAdmin from "@/pages/admin/Prizes";
import PredictionsAdmin from "@/pages/admin/PredictionsAdmin";
import "@/App.css";
import { useEffect } from "react";

function AppRoutes() {
  const { user, loading } = useAuth();

  useEffect(() => {
    document.title = "Quiniela Mundial 2026";
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0F1C] flex items-center justify-center">
        <div className="text-[#F4E39E] text-xl font-bold animate-pulse" style={{ fontFamily: 'Montserrat' }}>
          Cargando...
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={user.role === 'admin' ? '/admin' : '/'} /> : <Login />} />
      <Route path="/" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
      <Route path="/partidos" element={<ProtectedRoute><Layout><Matches /></Layout></ProtectedRoute>} />
      <Route path="/predicciones" element={<ProtectedRoute><Layout><Predictions /></Layout></ProtectedRoute>} />
      <Route path="/ranking" element={<ProtectedRoute><Layout><Rankings /></Layout></ProtectedRoute>} />
      <Route path="/reglas" element={<ProtectedRoute><Layout><Rules /></Layout></ProtectedRoute>} />
      <Route path="/premios" element={<ProtectedRoute><Layout><Prizes /></Layout></ProtectedRoute>} />
      <Route path="/perfil" element={<ProtectedRoute><Layout><Profile /></Layout></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><Layout><AdminDashboard /></Layout></ProtectedRoute>} />
      <Route path="/admin/usuarios" element={<ProtectedRoute adminOnly><Layout><Users /></Layout></ProtectedRoute>} />
      <Route path="/admin/paises" element={<ProtectedRoute adminOnly><Layout><Countries /></Layout></ProtectedRoute>} />
      <Route path="/admin/etapas" element={<ProtectedRoute adminOnly><Layout><Stages /></Layout></ProtectedRoute>} />
      <Route path="/admin/estadios" element={<ProtectedRoute adminOnly><Layout><Stadiums /></Layout></ProtectedRoute>} />
      <Route path="/admin/sedes" element={<ProtectedRoute adminOnly><Layout><Venues /></Layout></ProtectedRoute>} />
      <Route path="/admin/partidos" element={<ProtectedRoute adminOnly><Layout><MatchesAdmin /></Layout></ProtectedRoute>} />
      <Route path="/admin/resultados" element={<ProtectedRoute adminOnly><Layout><Results /></Layout></ProtectedRoute>} />
      <Route path="/admin/predicciones" element={<ProtectedRoute adminOnly><Layout><PredictionsAdmin /></Layout></ProtectedRoute>} />
      <Route path="/admin/reglas" element={<ProtectedRoute adminOnly><Layout><RulesAdmin /></Layout></ProtectedRoute>} />
      <Route path="/admin/premios" element={<ProtectedRoute adminOnly><Layout><PrizesAdmin /></Layout></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster theme="dark" richColors position="top-center" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
